// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-404-js": require("gatsby-module-loader?name=component---src-pages-404-js!/home/ws/spaceland/modebewusst.bundfuerbildung.de/src/pages/404.js"),
  "component---src-pages-index-js": require("gatsby-module-loader?name=component---src-pages-index-js!/home/ws/spaceland/modebewusst.bundfuerbildung.de/src/pages/index.js")
}

exports.json = {
  "layout-index.json": require("gatsby-module-loader?name=path---!/home/ws/spaceland/modebewusst.bundfuerbildung.de/.cache/json/layout-index.json"),
  "404.json": require("gatsby-module-loader?name=path---404!/home/ws/spaceland/modebewusst.bundfuerbildung.de/.cache/json/404.json"),
  "index.json": require("gatsby-module-loader?name=path---index!/home/ws/spaceland/modebewusst.bundfuerbildung.de/.cache/json/index.json"),
  "404-html.json": require("gatsby-module-loader?name=path---404-html!/home/ws/spaceland/modebewusst.bundfuerbildung.de/.cache/json/404-html.json")
}

exports.layouts = {
  "layout---index": require("gatsby-module-loader?name=component---src-layouts-index-js!/home/ws/spaceland/modebewusst.bundfuerbildung.de/.cache/layouts/index.js")
}


// WEBPACK FOOTER //
// ./.cache/async-requires.js